export const SCRIPT_URL = process.env.REACT_APP_SCRIPT_URL;

export const RESERVED_FIELD_NAMES = [
  'id',
  'record_code',
  'record code',
  'code',
  'created_at',
  'created at',
  'date',
  'time',
  'date/time',
  'updated_at',
  'updated at',
  'school_id',
  'school id',
  'section_id',
  'section id',
];

export function isReservedFieldName(fieldName) {
  return RESERVED_FIELD_NAMES.includes(fieldName.trim().toLowerCase());
}
